const hangulToEngMap: Record<string, string> = {
  ㅂ: "q",
  ㅈ: "w",
  ㄷ: "e",
  ㄱ: "r",
  ㅅ: "t",
  ㅛ: "y",
  ㅕ: "u",
  ㅑ: "i",
  ㅐ: "o",
  ㅔ: "p",
  ㅁ: "a",
  ㄴ: "s",
  ㅇ: "d",
  ㄹ: "f",
  ㅎ: "g",
  ㅗ: "h",
  ㅓ: "j",
  ㅏ: "k",
  ㅣ: "l",
  ㅋ: "z",
  ㅌ: "x",
  ㅊ: "c",
  ㅍ: "v",
  ㅠ: "b",
  ㅜ: "n",
  ㅡ: "m",
  샹: "tId",
  드챙: "emCod",
  벼무샤쇼: "quantity",
  ㅑㅅ드챙ㄷ: "itemCode",
  ㅣㅐ수믇: "lotName",
  ㅑㅅ드ㅜ믇: "itemName",
  // 필요 시 확장
};

/**
 * 입력된 한글 자판 문자열을 QWERTY 영문 자판으로 변환.
 * 예: 'ㅂㅈㄷㄱ' → 'qwer'
 *
 * @param input 변환할 한글 문자열
 * @returns 변환된 영문 문자열
 */
export function convertHangulToEng(input: string): string {
  return input
    .split("")
    .map((char) => hangulToEngMap[char] || char)
    .join("");
}
